import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { FireStoreStripeAccountRecord, FireStoreStripeAccountRecordOnboardingLink } from "../../../../globalTypes/account.types";
import JSConfetti from 'js-confetti';


import { ButtonComponent } from "../../component/layout/element/button.component";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { AccountService } from "../../services/account.service";
import { Store } from "@ngrx/store";
import { accountFeature } from "../../store/account.store";
import { filter, take } from "rxjs";

@Component({
  selector: 'msh-onboarding',
  standalone: true,
  template:`
@if(
  !onBoardingCompleted 
  && onBoardingInfo 
  && (!onBoardingInfo.detailsSubmitted || !onBoardingInfo.transfersEnabled)
){
  <div class="flex flex-col justify-center p-8 max-w-5xl mt-12 mb-10 border border-navy-50 rounded shadow-lg mx-auto">
    @if(firstTime){
      <div class=" font-bold text-lg text-center">Success!</div>
      <div class=" mt-4 md:mx-12">
        Thanks for creating an account with Mobile Storehouse. If you are ready to keep going, complete your company registration so you can start listing items.  However, you have
Been through enough already, so have a break and browse the listings
      </div>
    } @else {
      <div class=" font-bold text-lg text-center">Payment processing account still pending...</div>
    }
    <div class="flex flex-wrap gap-16 mt-8 justify-center">
      <div class=" max-w-96">
        <div class="text-lg mb-4"><strong>What's Next?</strong> - Complete payment setup</div>
        <div class=" mb-6">
          What you will need:
          <div class="text-xs mt-3 grid grid-cols-3">
            <div>
              Company Info
              <ul class="block" role="list">
                <li>Address</li>
                <li>Contact Info</li>
                <li>Owner Structure</li>
              </ul>
            </div>
            <div>
              Owner/Rep Info
              <ul class="block" role="list">
                <li>Name</li>
                <li>Address</li>
                <li>Birthday & SSN</li>
              </ul>
            </div>
            <div>
              Bank Info (for deposits)
              <ul class="block" role="list">
                <li>Bank Name</li>
                <li>Routing Number</li>
                <li>Account Number</li>
              </ul>
            </div>
          </div>
            <div class="text-xs mt-2">And be ready to agree to the terms of service</div>
        </div>
        <msh-button (onClick)="followVerifyLink()" [cta]="'Complete your registration'"></msh-button>
      </div>
      <div class=" max-w-96">
        <div class="text-lg mb-4"><strong>Not ready for that commitment yet?</strong></div>
        <div class=" mb-6 flex flex-col gap-3">
          No worries, do it later. You can still...
          <msh-button [stealthMode]="true" [routerLink]="'/manage-listing/photos/new'" [cta]="'Post a listing'"></msh-button>
          <div class="text-center text-xs">(We just hold the funds until you complete registration)</div>
          <div class="text-center">or</div>
          <msh-button [routerLink]="'/listing/search'" [cta]="'Search for great deals'"></msh-button>
        </div>
      </div>
    </div>
  </div>
}
  `,
  styles: [],
  imports: [ButtonComponent, RouterModule],
})
export class OnBoardingComponent implements OnChanges {

    @Input() onBoardingInfo?: FireStoreStripeAccountRecord
    @Input() firstTime = false;
    onBoardingCompleted = false;
    justCompleted = false

    constructor(
      private router: Router,
      private store: Store,
      private accountService: AccountService,
      private route: ActivatedRoute,
    ){
      // if createAccountLinkRefresh get new link and redirect back immediately
      console.log({msg: this.route.snapshot.params})
      if(this.route.snapshot.params['type'] == "createAccountLinkRefresh") {
        console.log({msg: "get the refresh link"})
        this.store.select(accountFeature.selectLocation).pipe(filter(l=>!!l), take(1)).subscribe(async (location) =>{
          if(!location) throw new Error("No location");
          const linkDetails: FireStoreStripeAccountRecordOnboardingLink = await this.accountService.refreshOnboardingLink(location.id);
          window.location.href = linkDetails.url;
        })
      }
      if(this.route.snapshot.params['type'] == "createAccountLinkReturn") {
        console.log({msg: "returned from stripe"})
        this.onBoardingCompleted = true;
        const jsConfetti = new JSConfetti()

        jsConfetti.addConfetti({
         // emojis: ['💰', '💥', '🔪','💲'],// , '⚡️', '🍴', '💫'
          confettiColors: [
            '#E48133', '#b35d21', '#121e27', '#2C404F', '#ffd59e', '#ffe8c7',
          ],
        })
        this.justCompleted = true;
      }
    }

    ngOnChanges(changes: SimpleChanges): void {
      if(changes['onBoardingInfo']){
        if(this.onBoardingInfo?.chargesEnabled && this.onBoardingInfo.detailsSubmitted && this.onBoardingInfo.transfersEnabled) {
          if(this.route.snapshot.params['type'] == "createAccountLinkReturn"){
            this.justCompleted = true;
          } else {
            this.onBoardingCompleted = true;
          }
        }
      }
    }

    followVerifyLink(){
      if(this.onBoardingInfo?.currentOnboardingLink.url){
        console.log({l:this.onBoardingInfo?.currentOnboardingLink.url})
        window.location.href = this.onBoardingInfo?.currentOnboardingLink.url
      }
    }

}